import { Location } from '../../interfaces/app.interface';
import * as actionTypes from './appActionTypes';


// Generic update payload type
export type UpdateAppStatePayload = Partial<{
  selectedMode: number;
  companyId: number | null;
  currentLocation: Location | null;
  favoriteRestaurantId: number | null;
}>;

// Generic update action
export interface UpdateAppStateAction {
  type: typeof actionTypes.UPDATE_APP_STATE;
  payload: UpdateAppStatePayload;
}

export const updateAppState = (payload: UpdateAppStatePayload): UpdateAppStateAction => ({
  type: actionTypes.UPDATE_APP_STATE,
  payload,
});

// Fetch location actions
export interface FetchLocationAction {
  type: typeof actionTypes.FETCH_LOCATION;
}

export const fetchLocation = (): FetchLocationAction => ({
  type: actionTypes.FETCH_LOCATION,
});
